//
//
//
//
//
//
//


import addDebugCommands from '~/mixins/pages/addDebugCommands';

/**
 * Represents a page to be included into the jungfrau.ch iframe view
 */
export default {
    mixins: [addDebugCommands],
};

